import { Box } from '@mui/material';
import Authorized from '../../../../lib/middlewares/Authorized';
import { HamburgerMenuProps } from '../HamburgerMenu';
import HamburgerMenuItem from '../HamburgerMenuItem';
import HamburgerAccountItem from './HamburgerAccountItem';
import navMenuHandler from '../../../../lib/helper/nav-menu-handler';
import { useEffect, useState } from 'react';

const HamburgerNavMenu = ({ closeMenu }: HamburgerMenuProps) => {
    const [data, setData] = useState<(JSX.Element | undefined)[]>();

    useEffect(() => {
        navMenuHandler(HamburgerMenuItem, { onClick: closeMenu }).then((data) => {
            setData(data);
        });
    }, [closeMenu]);

    return (
        <>
            <Authorized>
                <Box>{data}</Box>
            </Authorized>
            <HamburgerAccountItem onClick={closeMenu} />
        </>
    );
};

export default HamburgerNavMenu;
